module.exports = __webpack_public_path__ + "static/media/book_first_ride.e309d22d.png";